<template>
	<div class="p-4 grid grid-cols-2 gap-6">
		<template v-for="(value, key) in attributes" :key="key">
			<div class="border rounded-lg p-4 bg-gray-50 shadow-sm">
				<p class="text-main-color font-semibold text-lg mb-2">{{ key }}</p>
				<div>
				<!-- Check if the value is an object -->
				<template v-if="typeof value === 'object' && value !== null">
					<template v-for="(innerValue, innerKey) in value" :key="innerKey">
					<p class="font-light text-base text-gray-600">{{ innerKey }}: {{ innerValue }}</p>
					</template>
				</template>

				<!-- Handle boolean-like strings -->
				<template v-else>
					<template v-if="value === 'true' || value === 'false'">
					<span class="text-2xl">
						<span v-if="value === 'true'"><IconChecked/></span>
						<span v-else ><IconUnchecked/></span>
					</span>
					</template>
					<template v-else>
					<p class="font-light text-base text-gray-600">{{ value }}</p>
					</template>
				</template>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import IconChecked from '@icons/IconChecked.vue'
import IconUnchecked from '@icons/IconUnchecked.vue'
export default {
	name: "InfoBlock",
	props: {
		attributes: []
	},
    components: {
        IconChecked, IconUnchecked
    }
}

</script>
